import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { CategoriesState } from "@insite/client-framework/Store/Data/Categories/CategoriesState";
import { assignById } from "@insite/client-framework/Store/Data/DataState";

import { Draft } from "immer";

const initialState: CategoriesState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    parentCategoryIdToChildrenIds: {},
    categoryDepthLoaded: {},
    errorStatusCodeById: {},
    categoryIdsCalled: [],
};

const reducer = {
    "CustomCategories/CustomCompleteLoadCategoriesById": (
        draft: Draft<CategoriesState>,
        action: { categoriesById: SafeDictionary<Category> },
    ) => {
        for (const categoryId in action.categoriesById) {
            assignById(draft, action.categoriesById[categoryId]!);
        }
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
